<template>
  <div class="bg-gray-21 p-3 rounded mb-2 row-hover" @click="onGoToRequest">
    <div class="d-flex align-items-center">
      <div class="flex-grow-1">
        <em
          class="fas fa-circle font-12 mr-1"
          :class="`color-${statusColor(data.statusId)}`"
        />
        <span class="color-gray-18 font-14">{{ data.statusName }}</span>
      </div>
      <span class="color-dark-blue font-12">{{ itemAge }}</span>
      <em class="fas fa-clock color-orange-light-2 font-12 ml-2" />
    </div>
    <div class="pl-3">
      <div class="d-flex">
        <span class="flex-grow-1 color-primary-4 font-16 font-weight-bold">
          {{ data.caseNumber }}
        </span>
        <div>
          <span class="color-dark-blue font-12">{{ data.region }}</span>
          <em class="fas fa-clock color-brown-1 font-12 ml-2" />
        </div>
      </div>
      <div>
        <span class="color-gray-18 font-14 mr-1">
          {{ $t('SubTypeName.HeaderText') }}:
        </span>
        <span class="color-black font-14">{{ data.caseType }}</span>
      </div>
      <div class="mt-n1">
        <span class="color-gray-18 font-14 mr-1">{{ $t('AssignedTo') }}:</span>
        <span class="color-black font-14">{{ assignedTo }}</span>
      </div>
      <div
        class="d-flex justify-content-end mt-n2 cursor-pointer"
        @click="onGoToRequest"
      >
        <em class="fas fa-circle-arrow-right color-gray-22" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

//utils
import { i18n } from '@/i18n.js';

//constants
import requestStatus, {
  requestStatusColor,
} from '@/utils/constants/requestStatus.js';

export default {
  name: 'RequestRow',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    days() {
      return `${this.data.days} ${i18n.t('Days')}`;
    },
    statusColor() {
      return (statusId) => {
        return {
          [requestStatus.Nuevo]: requestStatusColor[requestStatus.Nuevo],
          [requestStatus.Cancelado]:
            requestStatusColor[requestStatus.Cancelado],
          [requestStatus.EnProceso]:
            requestStatusColor[requestStatus.EnProceso],
          [requestStatus.DocumentoCarta]:
            requestStatusColor[requestStatus.DocumentoCarta],
          [requestStatus.Sometida]: requestStatusColor[requestStatus.Sometida],
          [requestStatus.DevueltoPorFaltaInformacion]:
            requestStatusColor[requestStatus.DevueltoPorFaltaInformacion],
          [requestStatus.Denegado]: requestStatusColor[requestStatus.Denegado],
          [requestStatus.RedaccionCarta]:
            requestStatusColor[requestStatus.RedaccionCarta],
          [requestStatus.Autorizado]:
            requestStatusColor[requestStatus.Autorizado],
          [requestStatus.CanceladoDE]:
            requestStatusColor[requestStatus.CanceladoDE],
          [requestStatus.DocumentoTesis]:
            requestStatusColor[requestStatus.DocumentoTesis],
        }[statusId ?? requestStatus.Unset];
      };
    },
    itemAge() {
      const itemCreateDate = moment(this.data.createdDate, 'YYYY-MM-DD');
      const today = moment(new Date());

      if (itemCreateDate.format('LL') == today.format('LL')) {
        return 'Hoy';
      } else {
        return today.diff(itemCreateDate, 'days') + ' ' + i18n.t('Days');
      }
    },
    assignedTo() {
      return this.data.assignedProfiles.join(', ') || i18n.t('NotAssigned');
    },
  },
  methods: {
    onGoToRequest() {
      this.$emit('on-go-to-request', this.data.caseNumber);
    },
  },
};
</script>
<style>
.row-hover:hover{
  cursor: pointer;
  background-color: #f5f5f5;
}
</style>